import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2023 Classic Portfolio. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
